/* eslint-disable  react/prop-types */

import React from 'react';

const SuccessIcon = ({ width = 16, height = 16, style = {}, fill = '#2F9E44' }) => (
  <svg
    style={style}
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="success-icon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm3.766-9.357a1 1 0 0 0-1.532-1.286l-3.477 4.14-1.03-1.092a1 1 0 0 0-1.455 1.372l1.164 1.234.454.482.134.142.036.038.01.01.002.002v.001L6.8 11l-.728.686a1 1 0 0 0 1.494-.043l4.2-5z"
      fill={fill}
    />
  </svg>
);

export default SuccessIcon;
